import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { ISocialMediaAnalysisHistory } from "../../../store/repIQSocialMediaAnalysisHistory/types";

interface IProps {
    title: string;
    name: string;
    selectedNetworkID: number;
    presetProfileAverage: number;
    presetProfileBenchmarkHigh: number;
    presetProfileBenchmarkLow: number;
}

const ScoreHistory: React.FunctionComponent<IProps> = (props) => {
    const AllHistory: ISocialMediaAnalysisHistory[] = useSelector(
        (state: ApplicationState) => state.repIQSocialMediaAnalysisHistoryState && state.repIQSocialMediaAnalysisHistoryState.socialMediaAnalysisHistory
    );
    const [data, setData] = useState({} as any);

    const options = {
        curveType: "function",
        focusTarget: "category",
        chartArea: {
            left: 30,
            top: 10,
            right: 30,
            // width:"100%",
            // height:"100%"
        },
        legend: { position: "bottom" },
        isStacked: true,
        series: {
            // My Score
            0: {
                color: "#306E91",
                type: "line",
                pointSize: 10,
            },

            // Preset Profile Average
            1: {
                color: "#54B5A6",
                type: "line",
                pointSize: 0,
            },

            // Avg Low
            2: {
                areaOpacity: 0,
                color: "transparent",
                visibleInLegend: false,
                pointSize: 0,
                tooltip: false,
            },

            // Avg High
            3: {
                areaOpacity: 0.1,
                color: "#54B5A6",
                visibleInLegend: true,
                lineWidth: 0,
                pointSize: 0,
                tooltip: false,
            },
        },
        seriesType: "area",
        title: "",
        vAxis: {
            ticks: [0, 20, 40, 60, 80, 100],
            title: "",
            baselineColor: "#e3e3e3",
            gridlines: { color: "#e3e3e3" },
        },
        hAxis: {
            title: "",
            baselineColor: "#e3e3e3",
            gridlines: { color: "#e3e3e3" },
            //baselineColor: '#CCCCCC'
        },
    };

    useEffect(() => {
        if (props) {
            let obj = {
                cols: [
                    { label: "Period" },
                    { label: "My Score", type: "number" },
                    { label: "Preset Profile Average", type: "number" },
                    { label: "Preset Profile Benchmark", type: "number" },
                    { label: "Preset Profile Benchmark", type: "number" },
                ],
                rows: [] as any,
            };
            let history: ISocialMediaAnalysisHistory[] = AllHistory.filter(
                (his: ISocialMediaAnalysisHistory) => his.networkID === props.selectedNetworkID && his.category === props.name
            );
            if (history && history.length > 0) {
                history.forEach((his: ISocialMediaAnalysisHistory) => {
                    let row = {
                        c: [
                            { v: his.month },
                            { v: Math.round(his.result * 100) },
                            { v: props.presetProfileAverage },
                            { v: props.presetProfileBenchmarkLow },
                            { v: props.presetProfileBenchmarkHigh - props.presetProfileBenchmarkLow },
                        ],
                    };
                    obj.rows.push(row);
                });
                setData(obj);
            }
        }
    }, [props]);

    return (
        <React.Fragment>
            <React.Fragment>
                <h3 className="content-sub-title">
                    {props.title} Score History <small>(Last 6 Months)</small>
                </h3>
                <div id="score-history-chart" className="margin-bottom-m"></div>
                <Chart
                    className={"m-chart-container"}
                    style={{ minHeight: "280px" }}
                    chartType="ComboChart"
                    loader={<div>Loading Chart</div>}
                    data={data}
                    options={options}
                    rootProps={{ "data-testid": "1" }}
                    chartEvents={[
                        {
                            eventName: "ready",
                            callback: ({ chartWrapper, google }) => {
                                window.addEventListener(
                                    "keydown",
                                    (event) => {
                                        if (event.key !== "Escape") return;
                                        event.stopPropagation();
                                        window.showtoolTip();
                                    },
                                    true
                                );
                                var chart = new google.visualization.ComboChart(document.getElementById("score-history-chart"));
                                var svg = chart.getContainer().getElementsByTagName("svg");
                                if (svg.length > 0) {
                                    svg[0].setAttribute("aria-label", "Score History Bar Graph");
                                }
                            },
                        },
                    ]}
                />
            </React.Fragment>
        </React.Fragment>
    );
};
export default ScoreHistory;
